<template>
  <el-card>
    <template #header>
      {{ `${systemTitle} verification data` }}
      <el-alert type="success" :closable="false" class="mt-1">
        <template #title>
          To change your {{ systemTitle }} info please contact your manager via
          Live Chat or email to
          <a class="support-email" href="mailto:support@traforama.com">
            support@traforama.com
          </a>
        </template>
      </el-alert>
    </template>
    <el-row type="flex" class="row-bg" justify="left">
      <el-col :xs="12" :sm="6" :lg="4"> Account Type </el-col>
      <el-col :xs="12" :sm="12" :lg="12">
        {{ accountType }}
      </el-col>
    </el-row>

    <el-row type="flex" class="row-bg" justify="left">
      <el-col :xs="12" :sm="6" :lg="4">
        {{ accountTitle }}
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6">
        {{ modelValue.account }}
      </el-col>
    </el-row>

    <el-row
      v-if="modelValue.account_type === ContactType.Personal"
      type="flex"
      class="row-bg"
      justify="left"
    >
      <el-col :xs="12" :sm="6" :lg="4"> First Name </el-col>
      <el-col :xs="12" :sm="12" :lg="6">
        {{ modelValue.first_name }}
      </el-col>
    </el-row>

    <el-row
      v-if="modelValue.account_type === ContactType.Personal"
      type="flex"
      class="row-bg"
      justify="left"
    >
      <el-col :xs="12" :sm="6" :lg="4"> Last Name </el-col>
      <el-col :xs="12" :sm="12" :lg="6">
        {{ modelValue.last_name }}
      </el-col>
    </el-row>

    <el-row
      v-if="modelValue.account_type === ContactType.Corporate"
      type="flex"
      class="row-bg"
      justify="left"
    >
      <el-col :xs="12" :sm="6" :lg="4"> Company Name </el-col>
      <el-col :xs="12" :sm="12" :lg="6">
        {{ modelValue.company_name }}
      </el-col>
    </el-row>

    <el-row type="flex" class="row-bg" justify="left">
      <el-col :xs="12" :sm="6" :lg="4"> Country </el-col>
      <el-col :xs="12" :sm="6" :lg="6">
        {{ modelValue.country_name }}
      </el-col>
    </el-row>

    <el-row type="flex" class="row-bg" justify="left">
      <el-col :xs="12" :sm="6" :lg="4"> Address </el-col>
      <el-col :xs="12" :sm="6" :lg="6">
        {{ modelValue.address }}
      </el-col>
    </el-row>
    <br />
    <el-row type="flex" class="row-bg" justify="left">
      <el-col :xs="12" :sm="6" :lg="4">
        <router-link
          to="/payment"
          class="el-button el-button--primary el-button--medium"
        >
          Back to payments
        </router-link>
      </el-col>
    </el-row>
  </el-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { ContactType, ContactTypeLabel, ContactTypeLabels } from '@/api/types'
import { SystemAccountTitle } from '@/interfaces/paymentProfiles'

export default defineComponent({
  name: 'Info',
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  setup(props, context) {
    // @ts-ignore: Object is possibly 'undefined'
    const accountType = ContactTypeLabels.find((l: ContactTypeLabel) => {
      return l.id === props.modelValue.account_type
    }).label
    const systemTitle = props.modelValue.title
    const accountTitle = SystemAccountTitle[props.modelValue.sid]

    return { ContactType, accountType, systemTitle, accountTitle }
  }
})
</script>

<style lang="scss">
.change-msg {
  padding: 10px 0 5px 0;
  margin-bottom: 5px;
}
</style>
